// Sold-out semantics are gated by the per-variant pre-order flag:
//
//   can_preorder truthy  -> the soft-block committed-stock model applies
//                           (orders beyond stock are accepted and fulfilled
//                           from the next production batch — never "sold out").
//   can_preorder falsy   -> classic hard sold-out behaviour: a zero-stock
//                           variant renders as sold out everywhere.
//
// "Sold out" = NOT pre-orderable AND available stock is 0, nothing else.

export function isVariantSoldOut(variant) {
  if (!variant || variant.can_preorder == null) return false;
  if (Number(variant.can_preorder) !== 0) return false;
  return (Number(variant.stock_quantity) || 0) === 0;
}

// A parent product is sold out when ALL of its visible variants are sold out.
export function isParentSoldOut(product) {
  const visible = (product?.variants || []).filter(v => !v.is_hidden);
  if (visible.length === 0) return true;
  return visible.every(v => isVariantSoldOut(v));
}